<template>
  <transition name="modal" v-if="editTrainingModule">
    <div class="modal-mask">
      <div class="modal-wrapper" @click.self="cancel">
        <div class="training-modal modal-container">
          <div class="modal-header">
            <h3>Edit Module</h3>
            <div class="btn-group">
              <button class="btn admin-btn-primary general" @click="switchGeneral">General</button>
              <button class="btn btn-default quiz" @click="switchQuiz">Quiz</button>
            </div>
            <h4 class="text-left" v-if="!showGeneral"><a href="#" @click.prevent="addQuestion"><strong>+ Add Question</strong></a></h4>
          </div>
          <div class="modal-body form-horizontal">
            <div
              class="training-general"
              v-if="showGeneral"
              >
              <div class="form-group">
                <label for="fieldName" class="control-label col-sm-3">Name</label>
                <div class="col-sm-9 input-group">
                  <input
                    id="fieldName"
                    class="form-control admin-form-control"
                    type="text" name="name"
                    v-model="currentModule.moduleName"
                    placeholder="Name">
                </div>
              </div>
              <div class="clearfix"></div>
              <div class="form-group">
                <label for="fieldDescription" class="control-label col-sm-3">Description</label>
                <div class="col-sm-9 input-group">
                  <input
                    id="fieldDescription"
                    class="form-control admin-form-control"
                    type="text" name="description"
                    v-model="currentModule.description"
                    placeholder="Description">
                </div>
              </div>
              <div class="clearfix"></div>
              <div class="form-group">
                <label for="fieldPoints" class="control-label col-sm-3">Points</label>
                <div class="col-sm-9 input-group">
                  <input
                    id="fieldPoints"
                    class="form-control admin-form-control"
                    type="number" name="points"
                    v-model="currentModule.points"
                    placeholder="Points">
                </div>
              </div>
              <div class="clearfix"></div>
              <div class="form-group">
                <label for="fieldUrl" class="control-label col-sm-3">Video URL</label>
                <div class="col-sm-9 input-group">
                  <input
                    id="fieldUrl"
                    class="form-control admin-form-control"
                    type="text" name="videoUrl"
                    v-model="currentModule.videoUrl"
                    placeholder="Video URL">
                </div>
              </div>
              <div class="form-group">
                <label for="fieldDisable" class="control-label col-sm-3">Disable</label>
                <div class="col-sm-9 input-group">
                    <!-- class="form-control admin-form-control" -->
                  <input
                    id="fieldDisable"
                    type="checkbox" name="disable"
                    v-model="currentModule.disabled">
                </div>
              </div>
              <div class="clearfix"></div>
            </div>
            <div
              class="training-questions"
              v-else
              >
              <div class="row">
                <div class="modal-sidebar col-md-3">
                  <a
                    href=""
                    v-for="(question, index) in currentModule.questions" :key="index"
                    :class="getQuestionClasses(index)"
                    @click.prevent="currentQuestionIndex = index"
                    >Question {{ index + 1 }}</a>
                </div>
                <div class="modal-main col-md-9">
                  <div
                    class="quiz-content"
                    v-if="currentQuestion"
                    >
                    <div v-if="!validRadios" class="row">
                      <div class="col-sm-12">
                        <div class="alert alert-danger">
                          There should be one correct answer.<br>
                          All answers entered should be checked yes or no.
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-12">
                        <input v-model="currentQuestion.text" type="text" class="form-control admin-form-control input-md" :placeholder="`Question ${currentQuestionIndex + 1}`">
                      </div>
                    </div>
                    <div class="clearfix"></div>
                    <br>
                    <div class="row answer">
                      <div class="col-sm-8">
                        <input v-model="currentQuestion.answerOne.text" type="text" class="form-control admin-form-control input-md" placeholder="Answer 1">
                      </div>
                      <div class="col-sm-4">
                        <div class="radio-container">
                          <span>Correct</span>
                          <label class="radio-inline">
                            <input v-model="currentQuestion.answerOne.correct" type="radio" class="inlineCheckbox1" :value="true">Yes</label>
                          <label class="radio-inline">
                            <input v-model="currentQuestion.answerOne.correct" type="radio" class="inlineCheckbox2" :value="false">No</label>
                        </div>
                      </div>
                    </div><!-- answer -->

                    <div class="row answer">
                      <div class="col-sm-8">
                        <input v-model="currentQuestion.answerTwo.text" type="text" class="form-control admin-form-control input-md" placeholder="Answer 2">
                      </div>
                      <div class="col-sm-4">
                        <div class="radio-container">
                          <span>
                            Correct
                          </span>
                          <label class="radio-inline">
                            <input v-model="currentQuestion.answerTwo.correct" type="radio" class="inlineCheckbox1" :value="true">Yes</label>
                          <label class="radio-inline">
                            <input v-model="currentQuestion.answerTwo.correct" type="radio" class="inlineCheckbox2" :value="false">No</label>
                        </div>
                      </div>
                    </div><!-- answer -->

                    <div class="row answer">
                      <div class="col-sm-8">
                        <input v-model="currentQuestion.answerThree.text" type="text" class="form-control admin-form-control input-md" placeholder="Answer 3">
                      </div>
                      <div class="col-sm-4">
                        <div class="radio-container">
                          <span>
                            Correct
                          </span>
                          <label class="radio-inline">
                            <input v-model="currentQuestion.answerThree.correct" type="radio" class="inlineCheckbox1" :value="true">Yes</label>
                          <label class="radio-inline">
                            <input v-model="currentQuestion.answerThree.correct" type="radio" class="inlineCheckbox2" :value="false">No</label>
                        </div>
                      </div>
                    </div><!-- answer -->

                    <div class="row answer">
                      <div class="col-sm-8">
                        <input v-model="currentQuestion.answerFour.text" type="text" class="form-control admin-form-control input-md" placeholder="Answer 4">
                      </div>
                      <div class="col-sm-4">
                        <div class="radio-container">
                          <span>
                            Correct
                          </span>
                          <label class="radio-inline">
                            <input v-model="currentQuestion.answerFour.correct" type="radio" class="inlineCheckbox1" :value="true">Yes</label>
                          <label class="radio-inline">
                            <input v-model="currentQuestion.answerFour.correct" type="radio" class="inlineCheckbox2" :value="false">No</label>
                        </div>
                      </div>
                    </div><!-- answer -->

                    <div class="row">
                      <div class="col-sm-12">
                        <textarea v-model="currentQuestion.explanation" class="form-control admin-form-control input-md" rows="7" placeholder="Correct Answer Explanation"></textarea>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-default" @click="cancel">Cancel</button>
            <button
              v-if="validRadios"
              class="btn admin-btn-primary"
              @click="save">Save</button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
export default {
  name: 'TrainingModal',
  props: ['editTrainingModule', 'currentModuleIndex', 'program', 'isNew'],
  watch: {
    editTrainingModule: function (val) {
      if (val) {
        this.trainingModuleOriginalData = JSON.parse(JSON.stringify(this.currentModule))
      } else {
        this.trainingModuleOriginalData = {}
      }
    }
  },
  data () {
    return {
      showGeneral: true,
      currentQuestionIndex: 0,
      trainingModuleOriginalData: {}
    }
  },
  computed: {
    currentModule: {
      get () {
        return this.program.loyaltyProgramTrainings[this.currentModuleIndex]
      },
      set (value) {
        this.program.loyaltyProgramTrainings[this.currentModuleIndex] = value
      }
    },
    currentQuestion () {
      return this.currentModule.questions[this.currentQuestionIndex] || false
    },
    validRadios () {
      // if there's answer text, there must be a selected radio
      // of all the selected radios, there must be one correct answer
      if (this.currentQuestion) {
        const answers = [
          this.currentQuestion.answerOne,
          this.currentQuestion.answerTwo,
          this.currentQuestion.answerThree,
          this.currentQuestion.answerFour
        ]
        // check that answers with text have a selected radio
        const validAnswers = answers.filter(answer => {
          if (Object.keys(answer).length === 0 && answer.constructor === Object) return false
          if (answer.text && answer.text.length > 0 && answer.correct === undefined) {
            return true
          }
          return false
        }).length === 0
        if (!validAnswers) return false

        return answers.map(answer => answer.correct).filter(radio => radio).length === 1
      }
      return true
    }
  },
  methods: {
    ...mapMutations('loyaltyProgram', {
      setProgram: 'SET_PROGRAM',
      updateProgram: 'UPDATE_PROGRAM'
    }),
    ...mapActions('loyaltyProgram', [ 'saveProgram' ]),
    reset () {
      this.showGeneral = true
      this.currentQuestionIndex = 0
    },
    save () {
      this.setProgram(this.program)
      this.saveProgram()
        .then(response => {
          this.reset()
          this.$emit('close')
        })
        .catch(err => {
          console.log(err)
        })
    },
    cancel () {
      if (this.isNew) {
        const copyWithoutLast = this.program.loyaltyProgramTrainings.slice(0, -1)
        this.updateProgram({ prop: 'loyaltyProgramTrainings', value: copyWithoutLast })
      } else {
        this.currentModule = this.trainingModuleOriginalData
      }
      this.reset()
      this.$emit('close')
    },
    switchGeneral () {
      this.showGeneral = true
      const quizBtn = document.querySelector('.quiz')
      const generalBtn = document.querySelector('.general')
      quizBtn.classList.add('btn-default')
      quizBtn.classList.remove('admin-btn-primary')
      generalBtn.classList.remove('btn-default')
      generalBtn.classList.add('admin-btn-primary')
    },
    switchQuiz () {
      this.showGeneral = false
      const quizBtn = document.querySelector('.quiz')
      const generalBtn = document.querySelector('.general')
      generalBtn.classList.add('btn-default')
      generalBtn.classList.remove('admin-btn-primary')
      quizBtn.classList.remove('btn-default')
      quizBtn.classList.add('admin-btn-primary')
    },
    getQuestionClasses (index) {
      if (index === this.currentQuestionIndex) {
        return 'active'
      }
    },
    addQuestion () {
      this.currentModule.questions.push({
        text: '',
        answerOne: {},
        answerTwo: {},
        answerThree: {},
        answerFour: {},
        explanation: ''
      })
    }
  }
}
</script>

<style scoped>
#fieldDisable {
  height: 34px;
  font-size: 18px;
  margin: unset;
}

.answer {
  margin-bottom: 10px;
}

.radio-inline {
  padding-top: 0px;
}

.radio-container {
  display: flex;
  align-items: flex-end;
  color: #969696;
  font-size: 1.4em;
  font-weight: bold;
}

.radio-container span {
  margin-right: 10px;
}

.training-modal {
  width: 85%;
  max-height: 80vh;
  overflow-y: auto;
}
.modal-enter-active, .modal-leave-active {
  transition: opacity .6s;
}
.modal-enter, .modal-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.modal-sidebar {
  padding-right: 0;
  border-right: 1px solid #efefef;
}

.modal-sidebar a {
  display: block;
  color: #000;
  padding: 10px;
  text-decoration: none;
  font-size: 16px;
  text-align: center;
}

.modal-sidebar a.active {
  background-color: #0033ab;
  color: #fff;
}

.modal-sidebar a:hover:not(.active) {
  background-color: #6291ff;
  color: white;
}

@media screen and (max-width: 768) {
  .sidebar a {text-align: center;}
}

.sidebar-link-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.sidebar-link-wrapper .back-btn {
  margin-top: auto;
}

</style>
